import React from 'react';
import { Link, useLocation } from "react-router-dom";
import Axios from "axios";
import { useState, useEffect } from 'react';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import 'react-toastify/dist/ReactToastify.css';
import { GetClients, UpdateUsersInfo } from '../apiconstants/constants';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Swal from 'sweetalert2';
import SuperAdminLayout from '../commonlayouts/adminlayout';
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function EditClientDetails() {
  let query = useQuery();
  var queryClientId= query.get("ClientId");

  const formSchema = Yup.object().shape({
    terms: Yup.bool() // use bool instead of boolean
      .oneOf([true], "You must accept the terms and conditions"),
    firstName: Yup.string().required('First Name is required'),
    lastName: Yup.string().required('Last Name is required'),
    mobile: Yup.string().required('Mobile Number is required'),
    email: Yup.string().email().required('Email is required'),
  logoURL: Yup.mixed()
  .test("required", "Logo is required", (value) => {
    return value instanceof File; // Ensure a file is selected
  })
  .test("fileSize", "File size is too large", (value) => {
    return value && value.size <= 2 *1024* 1024; // 2MB limit
  })
  .test("fileType", "Unsupported file format", (value) => {
    return value && /\.(jpg|jpeg|png)$/i.test(value.name);
  }), 
  })
  const clientID = localStorage.getItem("clientID")
  const formOptions = { resolver: yupResolver(formSchema) }
  const { register, handleSubmit, setValue, formState } = useForm(formOptions);
  const { errors } = formState
  const { isSubmitting } = formState;
  const [isLoading, setIsLoading] = useState(false);
  const [file, setFile] = useState();
  const[fileName,setFileName] = useState(null);
  const token = localStorage.getItem("jwtToken");
  useEffect(() => {
    Axios
      .get(GetClients.APIURL,
      { headers: { 'Authorization': `Bearer ${token}` } }
      )
      .then((response) =>  { 
        const filteredClients = response.data.filter((x)=>x.guid == queryClientId)
        console.log("filter",filteredClients)
    setValue("email",filteredClients[0].email)
    setValue("firstName",filteredClients[0].firstName)
    setValue("lastName",filteredClients[0].lastName)
    setValue("mobile",filteredClients[0].mobileNumber)
    setValue("CompanyName",filteredClients[0].companyName)
    setValue("logoURL",filteredClients[0].logoURL)
    setFileName(filteredClients[0].logoURL)
}
    )
      .catch((error) => console.error("Error fetching clients", error));
  }, []);

function handleResumeChange(event) {
  const file = event.target.files[0];
  if (!file) return;

  // Check file size (2MB max)
  const maxSize = 2 * 1024 * 1024; // 2MB
  if (file.size > maxSize) {
    Swal.fire({ text: 'File size is too large! Max 2MB allowed.' });
    return;
  }

  // Check allowed file types
  const allowedExtensions = /(\.png|\.jpg|\.jpeg)$/i;
  if (!allowedExtensions.exec(file.name)) {
    Swal.fire({ text: 'Invalid File Type!' });
    return;
  }

  setFile(file);
  setFileName(file.name);
  setValue("logoURL", file, { shouldValidate: true });
}

const onSubmit = (data) => { // Removed e parameter
  console.log("data", data);
  setIsLoading(true);
  
  const formData = new FormData();
  formData.append('firstName', data.firstName);
  formData.append('lastName', data.lastName);
  formData.append('CompanyName', data.CompanyName);
  formData.append('email', data.email);
  formData.append('mobileNumber', data.mobile);
  formData.append('LogoURL', file);
  formData.append('Guid', queryClientId);

  Axios.put(UpdateUsersInfo.APIURL, formData,{
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "multipart/form-data"
    }
  })  
    .then((result) => {
      setIsLoading(false);
      if (result.data.message === " Record upadted successfully") {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'upadted successfully',
          showConfirmButton: false,
          timer: 5000
        });
      }  else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Something went wrong',
          showConfirmButton: false,
          timer: 5000
        });
      }
    })
    .catch(error => {
      console.log("Error", error);
    });
};



  return (
    <SuperAdminLayout>
       <section>
          <div className="container-fluid mt-4 pb-5">
            <div className="row">
              <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Link to="/Admin/ListofallClients">
                    <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px', marginTop: 8 }} aria-hidden="true"></i>
                  </Link>
                  <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: 8 }}>Edit Client</h2>
                </div>
              </div>
            </div>
            <hr />
            <div className="card shadow-lg mt-5 p-5" style={{ border: "none" }}>
              <div className="row mt-2">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="row mt-2 p-0">
                    <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3">
                    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> First Name</Tooltip>)}>

<input
  placeholder='First Name'
  type="text"
  name="First Name"
  {...register("firstName")}
  className={`form-control shadow-sm ${errors.firstName ? 'is-invalid' : ''}`} />
</OverlayTrigger>
<div className="invalid-feedback"> {errors.firstName?.message
  }</div>


            <div className="mt-4">
   <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Email</Tooltip>)}>
                    <input
                      placeholder='Email'
                      type="email"
                      name="email"
                      disabled
                      {...register("email")}
                      className={`form-control shadow-sm`} />
                  </OverlayTrigger>
                  </div>
                  <div className="mt-4">
   <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Company Name</Tooltip>)}>
                    <input
                      placeholder='Company Name'
                      type="text"
                      name="CompanyName"
                      {...register("CompanyName")}
                      className={`form-control shadow-sm ${errors.CompanyName ? 'is-invalid' : ''}`} />
                  </OverlayTrigger>
                  <div className="invalid-feedback"> {errors.CompanyName?.message}</div>
                  </div>
                  </div>
  
                    <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3">
                     
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Last Name</Tooltip>)}>
                    <input
                      placeholder='Last Name'
                      type="text"
                      name="lastName"
                      {...register("lastName")}
                      className={`form-control shadow-sm ${errors.lastName ? 'is-invalid' : ''}`} />
                  </OverlayTrigger>
                  <div className="invalid-feedback"> {errors.lastName?.message}</div>
                  <div className="mt-4">

<OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Mobile Number</Tooltip>)}>
  <input
    placeholder='Mobile Number'
    type="text"
    name="mobile"
    {...register("mobile")}
    className={`form-control shadow-sm ${errors.mobile ? 'is-invalid' : ''}`} />
</OverlayTrigger>
<div className="invalid-feedback"> {errors.mobile?.message}</div>
<div className='mt-4'>
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>  Upload Logo (Filename should not contain spaces or special characters)</Tooltip>)}>

                  <input
  type="file"
  name="logoURL"
  id="logoURL"
  accept=".png, .jpg, .jpeg"
  className={`form-control shadow-sm mt-3 ${errors.logoURL ? 'is-invalid' : ''}`}
  onChange={handleResumeChange}
/></OverlayTrigger>
{fileName && <div style={{ fontSize: 13 }}> {fileName}</div>}
<div className="invalid-feedback">{errors.logoURL?.message}</div>

</div>

</div>
                    </div>
         
                  </div>
  
                  <div className="row mt-4 p-0">
                    <div className="col-12">
                      <Link to="/Admin/ListofallClients">
                        <button style={{ float: "right" }} className="btn btn-primary">
                          Cancel
                        </button>
                      </Link>
                      <button type='submit' style={{ float: "right" }} className="btn btn-primary mr-3">
                        {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                        Save
                      </button> &nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
    </SuperAdminLayout>

  )
}

export default EditClientDetails;